import { useRef } from 'react';
import { CTAButton } from '../../atoms';
import { useLanguage } from '@/contexts/LanguageContext';
import styles from './ManifestoText.module.css';

const LEGACY_SITE_URL = 'https://codex.lnr.agency/';
const FR_HIGHLIGHT = "L'agence";
const EN_HIGHLIGHT = 'An agency';

export const ManifestoText = ({ className }: { className?: string }) => {
  const { t, language } = useLanguage();

  const containerRef = useRef<HTMLDivElement>(null);
  const paragraphRef = useRef<HTMLParagraphElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const fullText = t('home.manifesto.text');
  const highlightWord = language === 'fr' ? FR_HIGHLIGHT : EN_HIGHLIGHT;
  const manifestoText = fullText.startsWith(highlightWord)
    ? fullText.slice(highlightWord.length)
    : fullText;

  return (
    <div
      ref={containerRef}
      className={`${styles.manifestoTextContainer} ${className || ''}`}
    >
      <p ref={paragraphRef} className={styles.manifestoText}>
        <span className={`${styles.gradientTextSpan} ${styles.spacedText}`}>
          {highlightWord}
        </span>
        <span className={'everettRegular'}>{manifestoText}</span>
      </p>
      <div className={styles.ctaContainer}>
        <CTAButton
          ref={buttonRef}
          onClick={() => {
            window.open(LEGACY_SITE_URL, '_blank');
          }}
          className={styles.ctaButton}
          data-gtm-label="manifesto-cta"
          data-gtm-location="home-manifesto"
        >
          {t('home.manifesto.cta')}
        </CTAButton>
      </div>
    </div>
  );
};
